export default __webpack_public_path__ + "media/images/logo-c3597be42a0741ef93179a20e5adedd7.png";